(function () {
    "use strict";

    angular.module("expedientesUriarteApp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider
            .state("lebaniego-control-donor", {
                parent: "entity",
                url: "/lebaniego-control-donor?page&sort&search",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlDonor",
                },
                views: {
                    "content@": {
                        templateUrl:
                            "app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante.html",
                        controller:
                            "LebaniegoYearControlDonorController",
                        controllerAs: "vm",
                    },
                },
                params: {
                    page: {
                        value: "1",
                        squash: true,
                    },
                    sort: {
                        value: "id,asc",
                        squash: true,
                    },
                    search: null,
                },
                resolve: {
                    pagingParams: [
                        "$stateParams",
                        "PaginationUtil",
                        function ($stateParams, PaginationUtil) {
                            return {
                                page: PaginationUtil.parsePage(
                                    $stateParams.page
                                ),
                                sort: $stateParams.sort,
                                predicate: PaginationUtil.parsePredicate(
                                    $stateParams.sort
                                ),
                                ascending: PaginationUtil.parseAscending(
                                    $stateParams.sort
                                ),
                                search: $stateParams.search,
                            };
                        },
                    ],
                },
            })
            .state("lebaniego-control-donor.new", {
                parent: "lebaniego-control-donor",
                url: "/new",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"]
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante-new.html",
                        controller: "LebaniegoYearControlDonorNewController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Nueva",
                    parent: "lebaniego-control-donor"
                },
                resolve: {
                    entity: function() {
                        return {
                            id: null
                        };
                    },
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            })
            .state("lebaniego-control-donor.edit", {
                parent: "lebaniego-control-donor",
                url: "/{id}/edit",
                data: {
                    authorities: ["ROLE_ADMIN", "ROLE_JUBILAR"],
                    pageTitle: "LebaniegoYearControlDonor"
                },
                views: {
                    "content@": {
                        templateUrl: "app/entities/lebaniego/lebaniego-control/lebaniego-control-donantes/lebaniego-control-donante-detail.html",
                        controller: "LebaniegoYearControlDonorDetailController",
                        controllerAs: "vm"
                    }
                },
                ncyBreadcrumb: {
                    label: "Lista",
                    parent: "lebaniego-control-donor"
                },
                resolve: {
                    entity: [
                        "$stateParams",
                        "LebaniegoYearControlDonor",
                        function ($stateParams, LebaniegoYearControlDonor) {
                            return LebaniegoYearControlDonor.get({
                                id: $stateParams.id
                            }).$promise;
                        }
                    ],
                    previousState: [
                        "$state",
                        function ($state) {
                            var currentStateData = {
                                name: $state.current.name || "lebaniego-control-donor",
                                params: $state.params,
                                url: $state.href(
                                    $state.current.name,
                                    $state.params
                                )
                            };
                            return currentStateData;
                        }
                    ]
                }
            });
    }
})();